function buildUrlWithParams(
  url: string,
  params: { [key: string]: string | boolean | null | undefined | number },
): URL {
  const resultUrl = new URL(url);
  let k: string;
  for (k in params) {
    let param = params[k];
    if (param === null || param === undefined) {
      continue;
    }
    if (typeof param === 'boolean') {
      param = param ? 'true' : 'false';
    }
    resultUrl.searchParams.append(k, param);
  }
  return resultUrl;
}

export { buildUrlWithParams };
